import style from "./TalisInputFieldPaste.module.scss";
import classNames from "classnames/bind";
import TitleLabel from "../Labels/TitleLabel";

const cx = classNames.bind(style);

export default function TalisInputFieldPaste(props: {
    title: string;
    autofocus?: boolean;
    value: string;
    onChanged: (v: string) => void;
    disabled?: boolean;
    error?: string;
}) {
    return (
        <div className={style.container}>
            <div className={style.title_container}>
                <TitleLabel
                    text={props.title}
                    color={"#fff"}
                    size={14}
                    fontWeight={"medium"}
                />

                <div style={{ flex: 1 }} />
            </div>

            <div
                className={cx(style.body_container, {
                    error: props.error,
                })}
            >
                <input
                    className={cx(
                        style.field,
                        {
                            error: props.error,
                        },
                        {
                            disabled: props.disabled,
                        }
                    )}
                    maxLength={999}
                    disabled={props.disabled}
                    value={props.value}
                    onChange={(e) => {
                        let value = e.target.value;

                        try {
                            //check base64 encodable
                            btoa(value);
                            props.onChanged(value);
                        } catch (e) {
                            //can't
                        }
                    }}
                    autoFocus={
                        window.innerWidth < 1000
                            ? false
                            : props.autofocus ?? false
                    }
                    type={"text"}
                    inputMode={"text"}
                />

                <div
                    className={style.pastebutton}
                    onClick={() => {
                        navigator.clipboard
                            .readText()
                            .then((r) => {
                                props.onChanged(r);
                            })
                            .catch((e) => {});
                    }}
                >
                    {"Paste"}
                </div>
            </div>

            <ErrorView title={props.error} />
        </div>
    );
}

function ErrorView(props: { title: string | undefined }) {
    if (!props.title) {
        return <div style={{ height: "30px" }} />;
    }

    return (
        <div className={style.error_container}>
            <div className={style.error_text}>{props.title}</div>
            <div style={{ flex: 1 }} />
        </div>
    );
}
